<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <div class="dialog-body" align="center">
      <p>确定删除拼团商品信息</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">点错了</el-button>
      <el-button type="primary" @click="confirmDelete">确认删除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteGroupBuyProduct } from '@/api/goods/groupBuyProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteGroupBuyProduct',
  data() {
    return {
      dialogVisible: false,
      deleteData: {}
    }
  },
  methods: {
    open(data) {
      this.deleteData = data
      this.dialogVisible = true
    },
    async confirmDelete() {
      try {
        const params = {
          groupId: this.deleteData.groupId,
          shopId: getShopId()
        }
        await deleteGroupBuyProduct(params)
        this.$message.success('删除成功')
        this.closeDialog()
        this.$emit('close')
      } catch (error) {
        console.error('删除拼团商品失败:', error)
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteData = {}
    }
  }
}
</script>

<style scoped>
.dialog-body {
  padding: 20px;
  font-size: 16px;
}
.dialog-footer {
  text-align: center;
}
</style>